/* =============================================================================
   Furniselan — Main Product Section Scripts
   Handles:
     1. Accordion content cleanup (removes empty RTE paragraphs)
     2. Custom Furniture Inquiry modal (open, close, escape key)
     3. Color swatch title sync & Ready Stock badge sync
     4. Accordion tabs smooth toggle
     5. Variant price updater (Tag discounts, MRP, Regular, Extra discount, EMI)
     6. Share button (WhatsApp, Facebook, X, Telegram, LinkedIn, Pinterest, Email, Copy)
     7. Master initialization
   ============================================================================= */

(function () {
  'use strict';

  if (window.__fsMainProductInit) return;
  window.__fsMainProductInit = true;

  /* ───────────────────────────────────────────────────────────────────────────
     1. Accordion Content Cleanup
     ─────────────────────────────────────────────────────────────────────────── */
  function cleanRteParagraphs() {
    document.querySelectorAll('.paccs-content.rte p').forEach(function (p) {
      var text = p.textContent.replace(/\u00a0/g, '').trim();
      if (!text && !p.querySelector('img, video, iframe, svg')) {
        p.remove();
      }
    });
  }

  /* ───────────────────────────────────────────────────────────────────────────
     2. Custom Furniture Inquiry Modal
     ─────────────────────────────────────────────────────────────────────────── */
  function initCustomModal() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-custom-modal-open]');
      if (openBtn) {
        e.preventDefault();
        var modal = document.querySelector('[data-custom-modal]');
        if (modal) {
          modal.removeAttribute('hidden');
          document.body.classList.add('lock');
        }
        return;
      }

      var closeBtn = e.target.closest('[data-custom-modal-close]');
      if (closeBtn) {
        e.preventDefault();
        var modal = document.querySelector('[data-custom-modal]');
        if (modal) {
          modal.setAttribute('hidden', '');
          document.body.classList.remove('lock');
        }
        return;
      }

      var buyBtn = e.target.closest('[data-buy-now]');
      if (buyBtn) {
        e.preventDefault();
        var form = buyBtn.closest('form');
        if (form) {
          var id = form.querySelector('[name="id"]')?.value;
          var qty = form.querySelector('[name="quantity"]')?.value || 1;
          if (id) {
            window.location.href = '/cart/' + id + ':' + qty;
          }
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var modal = document.querySelector('[data-custom-modal]:not([hidden])');
        if (modal) {
          modal.setAttribute('hidden', '');
          document.body.classList.remove('lock');
        }
      }
    });
  }

  /* ───────────────────────────────────────────────────────────────────────────
     3. Color Title & Ready Stock Badge Sync
     ─────────────────────────────────────────────────────────────────────────── */
  function initProductBadgesAndTitle() {
    /* Title follows the selected colour */
    var lbl = document.querySelector('[data-color-title]');
    function syncTitle(v) {
      if (!v) return;
      var titleEls = document.querySelectorAll('[data-product-title], .product__title');
      titleEls.forEach(function (titleEl) {
        var tColor = titleEl.querySelector('[data-title-color]');
        var tBase = titleEl.querySelector('[data-title-base]');
        var baseTxt = (tBase && tBase.textContent.trim()) || titleEl.getAttribute('data-title-base');
        if (tColor) {
          tColor.textContent = ' - ' + v;
        } else if (baseTxt) {
          titleEl.innerHTML = '<span data-title-base>' + baseTxt + '</span><span data-title-color> - ' + v + '</span>';
        }
      });
      var qvTitles = document.querySelectorAll('.quick-view__title, [data-qv-title-base]');
      qvTitles.forEach(function (qvTitle) {
        var qColor = qvTitle.querySelector('[data-qv-color]');
        var qBase = qvTitle.querySelector('[data-qv-base]');
        var qBaseTxt = (qBase && qBase.textContent.trim()) || qvTitle.getAttribute('data-qv-title-base');
        if (qColor) {
          qColor.textContent = ' - ' + v;
        } else if (qBaseTxt) {
          qvTitle.innerHTML = '<span data-qv-base>' + qBaseTxt + '</span><span data-qv-color> - ' + v + '</span>';
        }
      });
    }

    if (lbl && window.MutationObserver) {
      new MutationObserver(function () { syncTitle(lbl.textContent.trim()); })
        .observe(lbl, { childList: true, characterData: true, subtree: true });
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-color-swatch], .swatch');
      if (!b) return;
      var radio = b.querySelector('input[type="radio"]') || (b.matches('input') ? b : null);
      var val = b.getAttribute('data-color-value') || (radio && radio.value);
      if (!val) {
        var nameSpan = b.querySelector('.swatch__name');
        if (nameSpan) val = nameSpan.textContent.trim();
      }
      if (val) syncTitle(val);
    });

    document.addEventListener('change', function (e) {
      var radio = e.target.closest('input[data-option-select]');
      if (radio && radio.value) {
        syncTitle(radio.value);
      }
    });

    window.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      if (v.options && v.options.length) {
        var picker = document.querySelector('[data-color-picker]');
        var cIdx = picker ? parseInt(picker.getAttribute('data-option-index'), 10) : -1;
        if (cIdx > -1 && v.options[cIdx]) {
          syncTitle(v.options[cIdx]);
        } else {
          syncTitle(v.options[0]);
        }
      } else if (v.id) {
        var vScript = document.querySelector('[data-variants]');
        if (vScript) {
          try {
            var vars = JSON.parse(vScript.textContent);
            var match = vars.find(function (x) { return String(x.id) === String(v.id); });
            if (match && match.options && match.options.length) {
              var p = document.querySelector('[data-color-picker]');
              var idx = p ? parseInt(p.getAttribute('data-option-index'), 10) : 0;
              syncTitle(match.options[idx] || match.options[0]);
            }
          } catch (err) {}
        }
      }
    });

    /* Ready Stock / Made to Order badge follows the selected variant */
    var readyBadge = document.querySelector('[data-ready-badge]');
    var readyMapEl = document.querySelector('[data-ready-map]');
    var readyMap = {};
    if (readyMapEl) {
      try { readyMap = JSON.parse(readyMapEl.textContent); } catch (err) {}
    }

    function syncReady() {
      if (!readyBadge) return;
      var idInput = document.querySelector('form[data-product-form] input[name="id"]');
      if (!idInput) return;
      var val = readyMap[idInput.value];
      if (val === true || val === false) {
        readyBadge.hidden = false;
        readyBadge.classList.toggle('ready-stock--true', val);
        readyBadge.classList.toggle('ready-stock--false', !val);
        var labelEl = readyBadge.querySelector('[data-ready-label]');
        if (labelEl) {
          labelEl.textContent = val ? readyBadge.dataset.readyText : readyBadge.dataset.madeText;
        }
      } else {
        readyBadge.hidden = true;
      }
    }

    ['click', 'change'].forEach(function (t) {
      document.addEventListener(t, function () { setTimeout(syncReady, 0); });
    });
    window.addEventListener('popstate', function () { setTimeout(syncReady, 0); });
    setTimeout(syncReady, 0);
  }

  /* ───────────────────────────────────────────────────────────────────────────
     4. Accordion Tabs Smooth Toggle
     ─────────────────────────────────────────────────────────────────────────── */
  function initAccordions() {
    /* Keep Details & dimensions open by default; close other tabs initially */
    document.querySelectorAll('.paccs details[open]').forEach(function (d) {
      var summaryText = d.querySelector('summary') ? d.querySelector('summary').textContent : '';
      if (!d.classList.contains('paccs__details') && !d.querySelector('.spect') && !/details|dimension/i.test(summaryText)) {
        d.removeAttribute('open');
      }
    });

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.addEventListener('click', function (e) {
      var summary = e.target.closest('.paccs summary');
      if (!summary) return;
      var d = summary.parentNode;
      if (!d || d.tagName !== 'DETAILS') return;

      e.preventDefault();
      toggle(d, summary);
    });

    function toggle(d, summary) {
      if (d._anim) {
        try { d._anim.cancel(); } catch (err) {}
        d._anim = null;
      }

      var isOpen = d.hasAttribute('open');

      if (isOpen) {
        // Closing
        var startH = d.offsetHeight;
        var summaryH = summary ? summary.offsetHeight : 45;
        if (reduce || !d.animate) {
          d.removeAttribute('open');
          return;
        }

        d.style.overflow = 'hidden';
        var a = d._anim = d.animate(
          { height: [startH + 'px', summaryH + 'px'] },
          { duration: 240, easing: 'cubic-bezier(.4,0,.2,1)' }
        );
        a.onfinish = function () {
          if (d._anim !== a) return;
          d._anim = null;
          d.removeAttribute('open');
          d.style.height = '';
          d.style.overflow = '';
        };
      } else {
        // Opening
        d.setAttribute('open', '');
        var fullH = d.offsetHeight;
        var summaryH = summary ? summary.offsetHeight : 45;

        if (reduce || !d.animate) {
          return;
        }

        d.style.overflow = 'hidden';
        var a = d._anim = d.animate(
          { height: [summaryH + 'px', fullH + 'px'] },
          { duration: 280, easing: 'cubic-bezier(.4,0,.2,1)' }
        );
        a.onfinish = function () {
          if (d._anim !== a) return;
          d._anim = null;
          d.style.height = '';
          d.style.overflow = '';
        };
      }
    }
  }

  /* ───────────────────────────────────────────────────────────────────────────
     5. Variant Price Updater & Buy It Now Toggle
     ─────────────────────────────────────────────────────────────────────────── */
  var TAG_DISCOUNTS = [
    { tag: '10off', multiplier: 1 + 11.1 / 100,  label: '10%' },
    { tag: '15off', multiplier: 1 + 17.64 / 100, label: '15%' },
    { tag: '20off', multiplier: 1 + 25 / 100,    label: '20%' }
  ];

  function getProductTags() {
    var tagScript = document.querySelector('script[data-product-tags]');
    if (tagScript) {
      try {
        var parsed = JSON.parse(tagScript.textContent);
        if (Array.isArray(parsed)) {
          return parsed.map(function (t) { return String(t).trim().toLowerCase(); });
        }
      } catch (e) {}
    }
    var form = document.querySelector('form[data-product-form]');
    if (form && form.dataset.productTags) {
      return form.dataset.productTags.split(',').map(function (t) { return t.trim().toLowerCase(); });
    }
    return [];
  }

  function getEmiMonths() {
    var emiEl = document.querySelector('[data-product-emi]');
    return (emiEl && parseInt(emiEl.dataset.emiMonths, 10)) || 12;
  }

  function getVariants() {
    var el = document.querySelector('script[data-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function findVariant(id) {
    return getVariants().find(function (v) { return String(v.id) === String(id); }) || null;
  }

  function fmt(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      var tmpl = (window.money_format || '\u20B9{{amount}}');
      return window.Shopify.formatMoney(cents, tmpl);
    }
    return '\u20B9' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function calcPrices(variant) {
    var origPrice    = variant.price;
    var comparePrice = variant.compare_at_price;
    var productTags  = getProductTags();

    var tagMultiplier = 1;
    var tagLabel      = null;
    TAG_DISCOUNTS.forEach(function (td) {
      if (productTags.indexOf(td.tag) > -1) {
        tagMultiplier = td.multiplier;
        tagLabel      = td.label;
      }
    });

    var offerPrice   = origPrice;
    var regularPrice = Math.round(origPrice * tagMultiplier);
    var mrpPrice     = comparePrice || regularPrice;
    var hasCompare   = mrpPrice > offerPrice;

    var discountAmt  = hasCompare ? (mrpPrice - regularPrice) : 0;
    var discountPct  = hasCompare ? Math.round(discountAmt * 100 / mrpPrice) : 0;

    var extraAmt = (tagLabel && regularPrice > offerPrice) ? (regularPrice - offerPrice) : 0;
    var extraPct = tagLabel || null;

    return {
      mrpPrice:     mrpPrice,
      regularPrice: regularPrice,
      offerPrice:   offerPrice,
      hasCompare:   hasCompare,
      discountAmt:  discountAmt,
      discountPct:  discountPct,
      extraAmt:     extraAmt,
      extraPct:     extraPct
    };
  }

  function updatePriceDOM(p) {
    var compareRow = document.querySelector('[data-product-compare-row]');
    var compareEl  = document.querySelector('[data-product-compare-price]');
    var badgeEl    = document.querySelector('[data-product-discount-badge]');

    if (compareRow) compareRow.style.display = p.hasCompare ? '' : 'none';
    if (compareEl)  compareEl.textContent     = fmt(p.mrpPrice);
    if (badgeEl)    badgeEl.textContent        = p.discountPct + '% off';

    var regularRow = document.querySelector('[data-product-regular-row]');
    var regularEl  = document.querySelector('[data-product-regular-price]');

    if (regularRow) regularRow.style.display = p.hasCompare ? '' : 'none';
    if (regularEl)  regularEl.textContent     = fmt(p.regularPrice);

    var discountRow = document.querySelector('[data-product-discount-row]');
    var discountEl  = document.querySelector('[data-product-discount-amount]');

    var showExtra = p.hasCompare && p.extraAmt > 0;
    if (discountRow) discountRow.style.display = showExtra ? '' : 'none';
    if (discountEl && showExtra) {
      discountEl.textContent = '\u2212' + fmt(p.extraAmt) + (p.extraPct ? ' (' + p.extraPct + ')' : '');
    }

    var offerEl = document.querySelector('[data-product-price]');
    if (offerEl) offerEl.textContent = fmt(p.offerPrice);

    var emiEl = document.querySelector('[data-product-emi]');
    var emiMonths = getEmiMonths();
    if (emiEl && emiMonths > 0) {
      emiEl.textContent = fmt(Math.round(p.offerPrice / emiMonths)) + '/month';
    }
  }

  function getCurrentVariantId() {
    try {
      var u = new URLSearchParams(window.location.search);
      if (u.get('variant')) return u.get('variant');
    } catch (e) {}
    var inp = document.querySelector('form[data-product-form] input[name="id"]');
    if (inp && inp.value) return inp.value;
    var form = document.querySelector('form[data-product-form]');
    if (form && form.dataset.initialVariantId) return form.dataset.initialVariantId;
    return null;
  }

  function refreshPrices(variantId) {
    var vid = variantId || getCurrentVariantId();
    var v   = findVariant(vid);
    if (!v) return;
    updatePriceDOM(calcPrices(v));

    /* Buy It Now: hide when sold out, show when available */
    var isAvail    = !!v.available;
    var binGokwik  = document.getElementById('gokwik-buy-now');
    var binWrapper = document.getElementById('pdpBuyWrapper');
    var binTarget  = binGokwik || binWrapper;
    var binSoldOut = document.getElementById('bin-soldout-placeholder');

    if (isAvail) {
      if (binTarget)  binTarget.style.display  = '';
      if (binSoldOut) binSoldOut.style.display = 'none';
    } else {
      if (binTarget)  binTarget.style.display  = 'none';
      if (binSoldOut) binSoldOut.style.display = 'none';
    }
  }

  function initVariantPriceUpdater() {
    var pForm = document.querySelector('form[data-product-form]');
    if (pForm) pForm.addEventListener('change', function () { setTimeout(refreshPrices, 30); });

    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-color-swatch],[data-option-select]');
      if (sw) {
        var vid = sw.getAttribute('data-variant-id');
        setTimeout(function () { refreshPrices(vid || null); }, 30);
      }
    });

    ['variant:change'].forEach(function (ev) {
      window.addEventListener(ev, function (e) {
        var vid = e.detail && e.detail.variant && e.detail.variant.id;
        setTimeout(function () { refreshPrices(vid || null); }, 30);
      });
      document.addEventListener(ev, function (e) {
        var vid = e.detail && e.detail.variant && e.detail.variant.id;
        setTimeout(function () { refreshPrices(vid || null); }, 30);
      });
    });

    var _lastPriceVid = getCurrentVariantId();
    setInterval(function () {
      var nid = getCurrentVariantId();
      if (nid && nid !== _lastPriceVid) {
        _lastPriceVid = nid;
        refreshPrices(nid);
      }
    }, 150);

    refreshPrices();
  }

  /* ───────────────────────────────────────────────────────────────────────────
     6. Share button (WhatsApp, Facebook, X, Telegram, LinkedIn, Pinterest, Email, Copy)
     ─────────────────────────────────────────────────────────────────────────── */
  function initShare() {
    var modal = document.querySelector('[data-share-modal]');
    if (!modal) return;

    /* move to <body> so no parent overflow/sticky can clip it */
    document.querySelectorAll('body > [data-share-modal]').forEach(function (m) {
      if (m !== modal) m.remove();
    });
    if (modal.parentNode !== document.body) document.body.appendChild(modal);

    var toast = modal.querySelector('[data-share-toast]');
    var urlInput = modal.querySelector('[data-share-url]');
    var lastFocus = null;
    var toastTimer = null;

    function getData() {
      var titleEl = document.querySelector('[data-product-title]');
      var title = (titleEl ? titleEl.textContent : document.title).replace(/\s+/g, ' ').trim();
      var url = window.location.href.split('#')[0];
      try {
        var u = new URL(window.location.href);
        var v = u.searchParams.get('variant');
        url = u.origin + u.pathname + (v ? '?variant=' + encodeURIComponent(v) : '');
      } catch (e) {}
      var img = modal.getAttribute('data-share-image') || '';
      if (img.indexOf('//') === 0) img = 'https:' + img;
      return { title: title, url: url, image: img };
    }

    function buildLinks(d) {
      var t = encodeURIComponent(d.title);
      var u = encodeURIComponent(d.url);
      var links = {
        whatsapp: 'https://wa.me/?text=' + encodeURIComponent(d.title + ' ' + d.url),
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + u,
        x: 'https://twitter.com/intent/tweet?text=' + t + '&url=' + u,
        telegram: 'https://t.me/share/url?url=' + u + '&text=' + t,
        linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + u,
        pinterest: 'https://pinterest.com/pin/create/button/?url=' + u + '&media=' + encodeURIComponent(d.image) + '&description=' + t,
        email: 'mailto:?subject=' + t + '&body=' + encodeURIComponent(d.title + '\n' + d.url)
      };
      modal.querySelectorAll('[data-share-net]').forEach(function (a) {
        var net = a.getAttribute('data-share-net');
        a.setAttribute('href', links[net] || '#');
        if (net === 'pinterest') a.hidden = !d.image; /* Pinterest needs an image */
      });
    }

    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.textContent = ''; }, 2500);
    }

    function openModal() {
      var d = getData();
      buildLinks(d);
      if (urlInput) urlInput.value = d.url;
      if (toast) toast.textContent = '';
      lastFocus = document.activeElement;
      modal.hidden = false;
      var closeBtn = modal.querySelector('.fs-share__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function copyLink() {
      var d = getData();
      function fallback() {
        try {
          if (urlInput) { urlInput.value = d.url; urlInput.select(); urlInput.setSelectionRange(0, 99999); }
          document.execCommand('copy');
          showToast('Link copied!');
        } catch (e) { showToast('Press Ctrl/Cmd + C to copy'); }
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(d.url).then(function () { showToast('Link copied!'); }, fallback);
      } else {
        fallback();
      }
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-share-open]');
      if (opener) {
        e.preventDefault();
        var d = getData();
        /* Mobile: use native share sheet when available */
        if (navigator.share && window.matchMedia('(max-width: 993px)').matches) {
          navigator.share({ title: d.title, text: d.title, url: d.url }).catch(function (err) {
            if (!err || err.name !== 'AbortError') openModal();
          });
        } else {
          openModal();
        }
        return;
      }
      if (e.target.closest('[data-share-close]') && !modal.hidden) { e.preventDefault(); closeModal(); return; }
      if (e.target.closest('[data-share-copy]') && modal.contains(e.target)) { e.preventDefault(); copyLink(); return; }
      if (e.target.closest('[data-share-net]') && modal.contains(e.target)) {
        setTimeout(function () { if (!modal.hidden) closeModal(); }, 150);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  /* ───────────────────────────────────────────────────────────────────────────
     7. Master Initialization
     ─────────────────────────────────────────────────────────────────────────── */
  function init() {
    cleanRteParagraphs();
    initCustomModal();
    initProductBadgesAndTitle();
    initAccordions();
    initVariantPriceUpdater();
    initShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Expose refreshProductPrices globally */
  window.refreshProductPrices = refreshPrices;

})();